export const clientListRoute = {
  path: "/management/client",
  name: "client-list",
  component: () => import("@/ui/management/client/client-list.vue")
};